import React from 'react';
import {Section,SectionHeader} from '../ui/Section';
import {Tabs} from '../ui/Tabs';
import {Card} from '../ui/Card';

export const BarExperience=()=> {
const packagePricing=[
  {hours: "One Hour", bws: "$24", superior: "$29", deluxe: "$33"},
  {hours: "Two Hours", bws: "$28", superior: "$33", deluxe: "$37"},
  {hours: "Three Hours", bws: "$32", superior: "$37", deluxe: "$41"},
  {hours: "Four Hours", bws: "$36", superior: "$41", deluxe: "$45"},
  {hours: "Five Hours", bws: "$40", superior: "$45", deluxe: "$49"},
  {hours: "Six Hours", bws: "$44", superior: "$49", deluxe: "$53"},
];

const cashPrices=[
  {item: "Deluxe Brands", price: "$12"},
  {item: "Superior Brands", price: "$14"},
  {item: "Premium Beer", price: "$9"},
  {item: "Domestic Beer", price: "$7"},
  {item: "Assorted Wines", price: "$11"},
  {item: "Wine (Bottle)", price: "$28"},
  {item: "Soda / Water", price: "$4"},
  {item: "Red Bull", price: "$6"}
];

const tabs=[
  {label: "Hosted Bar Packages", content: (
    <div className="space-y-6">
      <div className="overflow-x-auto">
        <table className="w-full min-w-[600px] text-left border-collapse">
          <thead>
            <tr>
              <th className="py-4 px-6 border-b-2 border-warm-stone/50 font-serif text-xl text-deep-charcoal">Duration</th>
              <th className="py-4 px-6 border-b-2 border-warm-stone/50 font-serif text-xl text-deep-charcoal">Beer/Wine/Soda</th>
              <th className="py-4 px-6 border-b-2 border-warm-stone/50 font-serif text-xl text-deep-charcoal">Superior Brands</th>
              <th className="py-4 px-6 border-b-2 border-warm-stone/50 font-serif text-xl text-deep-charcoal">Deluxe Brands</th>
            </tr>
          </thead>
          <tbody>
            {packagePricing.map((row,idx)=> (
              <tr key={idx} className="hover:bg-aged-ivory/50 transition-colors">
                <td className="py-4 px-6 border-b border-warm-stone/20 font-medium">{row.hours}</td>
                <td className="py-4 px-6 border-b border-warm-stone/20">{row.bws}</td>
                <td className="py-4 px-6 border-b border-warm-stone/20">{row.superior}</td>
                <td className="py-4 px-6 border-b border-warm-stone/20">{row.deluxe}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <div className="p-6 bg-aged-ivory rounded-xl text-xs space-y-2 text-deep-charcoal/70">
        <p>• Shots with a per-person-per-hour package are $10 per person.</p>
        <p>• Deluxe/Superior include wine, beer, champagne (excluding toast), liquors, cordials, mixers, sodas, water, and garnishes.</p>
        <p>• All prices are subject to applicable sales tax. Brands are subject to availability.</p>
      </div>
    </div>
  )},
  {label: "Cash & Specialty Bar", content: (
    <div className="grid lg:grid-cols-2 gap-8">
      <div className="bg-white p-8 rounded-2xl border border-warm-stone/30 shadow-sm">
        <h4 className="font-serif text-2xl text-deep-charcoal mb-4">Cash Bar Service</h4>
        <ul className="space-y-3 text-deep-charcoal/80 text-sm font-light mb-6">
          <li>• Minimum of $3,500 in sales required.</li>
          <li>• Standard bar setup fee applies.</li>
          <li>• All alcohol provided via Padua/Chantrelles licensing. No outside alcohol allowed.</li>
        </ul>
        <div className="grid grid-cols-2 gap-3">
          {cashPrices.map((p,i)=> (
            <div key={i} className="flex justify-between border-b border-warm-stone/10 py-1">
              <span className="text-xs">{p.item}</span>
              <span className="font-bold text-estate-bronze">{p.price}</span>
            </div>
          ))}
        </div>
      </div>
      <div className="grid grid-cols-2 gap-4">
        {[
          {name: "Mocktail Bar", price: "$20/pp"},
          {name: "Champagne Greet", price: "$6/pp"},
          {name: "House Toast", price: "$3/pp"},
          {name: "Soda Bar", price: "$9/pp"},
          {name: "Hot Chocolate", price: "$5/pp"},
          {name: "Lemonade Stand", price: "$5/pp"}
        ].map((bar,i)=> (
          <Card key={i} className="p-4 border-none shadow-soft text-center flex flex-col justify-center">
            <p className="text-[9px] font-bold text-estate-bronze uppercase tracking-widest mb-1">{bar.name}</p>
            <p className="font-serif text-xl text-deep-charcoal">{bar.price}</p>
          </Card>
        ))}
      </div>
    </div>
  )}
];

return (
  <Section id="bar" bg="bg-aged-ivory">
    <SectionHeader title="The Bar Experience" subtitle="From hosted brand packages to specialty stations, tailored for your celebration." />
    <div className="bg-white rounded-[2rem] p-5 md:p-10 lg:p-12 shadow-soft border border-warm-stone/10">
      <Tabs tabs={tabs} />
    </div>
  </Section>
);
};